module.exports = __webpack_public_path__ + "img/UserManagement-dark.d6f47afc.svg";